import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const SECTEUR_ACTIVATE_ENDPOINTS = {
  base: `${BASE_URL}api/secteur-activite/`,
  detail: (id) => `${SECTEUR_ACTIVATE_ENDPOINTS.base}${id}/`,
};

class SecteurActivite {
  endpoints = SECTEUR_ACTIVATE_ENDPOINTS;

  create(payload) {
    return request({
      url: this.endpoints.base,
      method: "POST",
      body: payload,
    });
  }

  update(payload) {
    return request({
      url: this.endpoints.detail(payload._id),
      method: "PUT",
      body: payload,
    });
  }

  delete(id) {
    return request({
      url: this.endpoints.detail(id),
      method: "DELETE",
    });
  }

  async block(ids){
    return await request({
      url: this.endpoints.base,
      body: ids,
      method: "DELETE",
    });
  }
}

export const SecteurActiviteService = new SecteurActivite();
